import axios from "../../axios";

// 上移
export const moveUp = (data) => {
  return axios({
    url: '/system/commonPage/moveUp',
    method: 'post',
    data
  })
};

// 下移
export const moveDown = (data) => {
  return axios({
    url: '/system/commonPage/moveDown',
    method: 'post',
    data
  })
};

// 导出
export const exportExcel = (data) => {
  return axios({
    url: '/system/commonPage/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/sys/commonPage.js